export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const secondaryText = isDark ? theme?.palette?.text?.secondary : '#00000099';
  const infoBackground = isDark ? '#000000' : '#E5F6FD';
  const infoText = isDark ? '#B8E7FB' : '#014361';
  const infoIcon = isDark ? '#29B6F6' : '#0288D1';

  return {
    container: {
      width: { xs: 'calc(100vw - 32px)', sm: 560 },
      maxWidth: { xs: 343, sm: 560 },
      maxHeight: '90vh',
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxSizing: 'border-box',
      outline: 'none',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: theme?.typography?.fontFamily,
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '1rem',
      px: '1rem',
      pt: '1.5rem',
      pb: 0,
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      m: 0,
    },
    closeButton: {
      color: theme?.palette?.grey?.[500],
      flexShrink: 0,
      mt: '-0.3rem',
      mr: '-0.5rem',
    },
    content: {
      flex: 1,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      px: '1rem',
      pt: '0.5rem',
      pb: '1.5rem',
      gap: '1rem',
      width: '100%',
    },
    subtitle: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
      color: secondaryText,
      m: 0,
    },
    toolsListWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      width: '100%',
      '& .MuiFormControlLabel-root': {
        m: 0,
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        gap: '0.5rem',
      },
      '& .MuiFormControlLabel-label': {
        flex: 1,
        minWidth: 0,
      },
    },
    radio: {
      height: '38px',
      width: '38px',
    },
    toolListItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px',
    },
    toolAvatar: {
      height: '32px',
      width: '32px',
      borderRadius: '8px',
      flexShrink: 0,
      cursor: 'default',
      backgroundColor: 'transparent',
    },
    toolTitle: {
      fontSize: '1rem',
      fontFamily: theme?.typography?.fontFamily,
      color: theme?.palette?.text?.primary,
      lineHeight: '150%',
      letterSpacing: '0.15px',
      margin: 0,
    },
    toolDescription: {
      fontSize: '0.75rem',
      color: theme?.palette?.text?.secondary,
      fontFamily: theme?.typography?.fontFamily,
      letterSpacing: '0.15px',
    },
    infoBanner: {
      background: infoBackground,
      px: '12px',
      py: '10px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '8px',
      borderRadius: '8px',
    },
    infoIcon: {
      color: infoIcon,
      height: '22px',
      width: '22px',
      flexShrink: 0,
      mt: '1px',
    },
    infoText: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
      color: infoText,
      m: 0,
    },
    footer: {
      display: 'flex',
      flex: 'none',
      alignItems: 'center',
      justifyContent: 'flex-end',
      boxSizing: 'border-box',
      mt: '0.5rem',
    },
    toolDetailsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'self-start',
      justifyContent: 'center',
      paddingLeft: '0.5rem',
      flex: 1,
      minWidth: 0,
      width: '100%',
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 400,
    },
    titleField: {
      ml: '3rem',
      mt: '-0.25rem',
      flex: 1,
      minWidth: 0,
      mr: '1rem',
      '& .MuiFormHelperText-root': {
        display: 'none',
      },
    },
    extensionIcon: { color: theme?.palette?.text?.primary, cursor: 'default' },
    nextButton: {
      width: '76px',
      maxWidth: '76px',
      height: '42px',
      maxHeight: '42px',
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    toolContainer: {
      mt: '0.5rem',
      maxHeight: { xs: '18rem', md: '28rem' },
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  };
};
